import { Download, Paperclip } from "lucide-react";
import type { EntityType } from "@repo/types/enums";
import type { RecordId } from "@repo/types/ui/tables";
import { useGetFileAssetsByEntityId } from "../../hooks/queries/useFileAssets";
import { useSettings } from "../../hooks/queries";

interface FileAttachmentsListProps {
  entityId: RecordId;
  entityType: EntityType;
}

export default function FileAttachmentsList({
  entityId,
  entityType,
}: FileAttachmentsListProps) {
  const { data: files } = useGetFileAssetsByEntityId(entityId, entityType);
  const { data: coreSettings } = useSettings();

  if (!entityId) {
    return <div className="text-gray-400 text-xs"></div>;
  }

  if (!files || files.length === 0) {
    return null;
  }

  const baseUrl = import.meta.env.VITE_APP_URL + "/File/GetFile";

  let folderPath = coreSettings?.AzureStorageFolderName;

  if (coreSettings?.AzureStorageTenantFolderName) {
    folderPath += "/" + coreSettings?.AzureStorageTenantFolderName;
  }

  return (
    <div className="flex items-start space-x-2">
      <div className="">
        <Paperclip size={16} />
      </div>

      <div className="flex space-x-2">
        {files.map((file, index) => (
          <div
            key={index}
            className="h-7 cursor-pointer text-gray-600 text-sm bg-blue-200 border-gray-50 rounded p-1"
          >
            <a
              href={`${baseUrl}?filePath=${folderPath}/${file.FilePath}`}
              target="_blank"
              className="flex items-center justify-center space-x-1"
            >
              <div>{file.OriginalFileName}</div>
              <div>
                <Download size={16} />
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
